var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6183 0H2.38022C1.06593 0 -0.000732422 1.06667 -0.000732422 2.38095V17.619C-0.000732422 18.9333 1.06593 20 2.38022 20H17.6183C18.9326 20 19.9993 18.9333 19.9993 17.619V2.38095C19.9993 1.06667 18.9326 0 17.6183 0ZM6.18974 7.61905V16.6667H3.3326V7.61905H6.18974ZM3.3326 4.98571C3.3326 4.31905 3.90403 3.80952 4.76117 3.80952C5.61832 3.80952 6.15641 4.31905 6.18974 4.98571C6.18974 5.65238 5.65641 6.19048 4.76117 6.19048C3.90403 6.19048 3.3326 5.65238 3.3326 4.98571ZM16.6659 16.6667H13.8088C13.8088 16.6667 13.8088 12.2571 13.8088 11.9048C13.8088 10.9524 13.3326 10 12.1421 9.98095H12.104C10.9516 9.98095 10.4755 10.9619 10.4755 11.9048C10.4755 12.3381 10.4755 16.6667 10.4755 16.6667H7.61832V7.61905H10.4755V8.8381C10.4755 8.8381 11.3945 7.61905 13.2421 7.61905C15.1326 7.61905 16.6659 8.91905 16.6659 11.5524V16.6667Z",
    fill: "#152333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.46afa90effe21e30e45e6ae995720f1e.svg";
export { ForwardRef as ReactComponent };